export class TabInterface {
    selected: boolean;
}